import * as React from 'react';

interface ILogoGoldmanProps {
  className?: string;
  color?: string;
}

export const LogoGoldman: React.FC<React.PropsWithChildren<ILogoGoldmanProps>> = props => (
  <svg viewBox="0 0 50 25" enableBackground="new 0 0 50 25" className={props.className}>
    <g>
      <g>
        <path
          fill={props.color || '#fff'}
          d={`M45.6,11.8h-1.9V4.2h1.8v0.8c0.2-0.5,0.8-1,1.5-1c1.2-0.1,2.1,0.7,2.1,2.3v5.5h-2V6.1c0-0.7,
                0-1.2-0.4-1.4c-0.2-0.1-0.4,0-0.7,0.2c-0.3,0.3-0.4,0.6-0.4,1.2C45.6,6.2,45.6,11.8,45.6,11.8z M14.8,8c0,
                1.4-0.4,2.6-1.3,3.3c-0.4,0.4-1,0.7-1.7,0.7c-0.7,0-1.2-0.3-1.7-0.7C9.4,10.6,8.9,9.4,8.9,8c0-1.4,0.5-2.6,
                1.3-3.3c0.5-0.4,1-0.7,1.7-0.7c0.7,0,1.2,0.3,1.7,0.7C14.3,5.4,14.8,6.7,14.8,8z M12.5,
                4.9c-0.2-0.3-0.3-0.5-0.7-0.5c-0.3,0-0.6,0.2-0.7,0.5c-0.3,0.6-0.3,1.7-0.3,3.1c0,1.4,0,2.5,0.3,3.1c0.1,0.3,
                0.3,0.5,0.7,0.5c0.4,0,0.6-0.2,0.7-0.5c0.2-0.6,0.2-1.7,0.2-3.1C12.8,6.7,12.8,5.5,12.5,4.9z M31,14.7c-1.5,
                0-2.4,0.8-2.4,2.2c0,1,0.7,1.5,1.9,2.2c1.1,0.6,1.5,1.1,1.5,1.8S31.4,22,30.7,
                22c-1.1-0.1-1.5-1-1.8-2.4h-0.4v2.8c0,0,1.7,0,2.2,0c1.2,0,2.6-0.8,
                2.6-2.4c0-1.5-1-1.9-2.3-2.6c-1-0.6-1.2-1-1.1-1.5c0.1-0.5,0.6-0.8,1.1-0.8c0.9,0.1,1.2,0.8,1.5,
                1.6h0.4v-2C32.9,14.7,31.5,14.7,31,14.7z M35.3,11.8V6.3c0-1.6-0.8-2.3-2.1-2.3c-0.8,0.1-1.3,0.6-1.6,1.1C31.5,
                4.4,30.8,4,30,4.1c-0.7,0.1-1.3,0.5-1.5,1V4.2h-1.7v7.5h1.9c0,0,0-5.5,0-5.7c0-0.6,0.1-0.9,0.4-1.2c0.2-0.2,
                0.4-0.2,0.6-0.2c0.4,0.1,0.4,0.7,0.4,1.4v5.7H32V6c0-0.5,0.1-0.8,0.4-1.1c0.2-0.2,0.4-0.2,0.6-0.2c0.4,0.1,0.5,
                0.7,0.5,1.4v5.7H35.3z M16,11.8H18V2.7H16V11.8z M23.1,11.8v-0.7c-0.2,0.4-0.6,0.8-1.4,0.8c-1.9,
                0-2.4-2.5-2.4-4.1c0.1-2.3,1.2-3.7,2.6-3.7c0.6,0,0.9,0.3,1.1,0.7V2.7h2v9.1H23.1z M22.1,4.6c-0.7,0-0.8,
                1.7-0.8,3.2c0,0.9,0,1.7,0.1,2.4c0.1,0.7,0.3,1.2,0.7,1.2c0.3,0,0.4-0.1,0.6-0.3C23.1,10.4,23,9,23,7.9c0-1.1,
                0-2.4-0.4-3C22.4,4.7,22.3,4.6,22.1,4.6z M39.6,4.1c-1.6,0-2.7,0.8-2.6,1.9c0.1,0.6,0.5,0.8,0.9,0.8c0.6,0.1,
                1.2-0.2,1.1-1c-0.1-0.5-0.4-0.5-0.4-0.8c0-0.3,0.4-0.4,0.6-0.5c0.6,0,0.8,0.2,0.8,0.7c0,0.5,0,0.8,0,1.2c0,
                0.4-0.1,0.5-1.2,1c-1.2,0.5-2.2,0.8-2.2,2.5c0,1.7,1.2,2.1,1.8,2.1c0.8,0,1.4-0.4,
                1.7-1v0.8H42V6.2c0-1-0.3-1.5-0.8-1.7C40.7,4.2,40.3,4.1,39.6,4.1z M40,9.6c0,0.8-0.2,1.5-0.6,1.7c-0.3,
                0.1-0.7,0-0.8-0.6c-0.1-0.7-0.1-1.1,0-1.5c0.1-0.6,0.2-1.1,0.8-1.5L40,7.3C40,7.6,40,9.6,40,9.6z M12,
                14.7c-1.6,0-2.7,0.8-2.6,1.8c0.1,0.6,0.5,0.8,0.9,0.9c0.6,0,1.2-0.3,1.1-1c-0.1-0.5-0.4-0.5-0.4-0.9c0-0.3,
                0.4-0.4,0.6-0.4c0.6-0.1,0.8,0.2,0.8,0.7c0,0.5,0,0.8,0,1.2c0,0.4-0.1,0.5-1.2,1c-1.1,0.5-2.2,0.8-2.2,2.5c0,
                1.7,1.1,2,1.8,2c0.8,0,1.4-0.4,1.7-1v0.8h1.8v-5.6c0-1-0.3-1.4-0.8-1.8C13.2,14.8,12.8,14.7,12,14.7z M12.5,
                20.1c0,0.8-0.2,1.5-0.7,1.7c-0.3,0.2-0.7,0.1-0.7-0.6c-0.1-0.6-0.1-1.1,0-1.5c0.1-0.6,0.2-1.1,
                0.8-1.5l0.6-0.4C12.5,18.1,12.5,20.1,12.5,20.1z M27.1,16.9c0-1.6-0.8-2.4-2.1-2.3c-0.6,0.1-1.1,0.3-1.4,
                0.7v-2.2h-1.9v5.2c0,1.9-1.3,3.7-2.7,3.7c-0.9,0-1.2-0.7-1.3-1.5c-0.2-1.1-0.2-2.4-0.1-3.8c0.1-0.9,0.3-1.6,
                1-1.6c0.5,0,0.5,0.3,0.3,0.6c-0.2,0.3-0.6,0.6-0.4,1.2c0.2,0.7,1.2,0.8,1.7,0.3c0.4-0.4,0.3-1.2,
                0.1-1.6c-0.3-0.6-0.9-0.8-1.7-0.8c-1.1,0-3.1,1-3.1,4c0,3.3,2.1,3.8,3.2,3.8c1.3,0,2.5-1.2,
                2.8-2.1v2h1.9v-5.7c0-0.6,0.1-0.9,0.4-1.2c0.2-0.2,0.5-0.2,0.7-0.2c0.4,0.1,0.4,0.7,0.4,1.4v5.7h1.9V16.9z M5,
                2.5c-2.7,0-4.1,2.6-4.1,5c-0.1,2.4,0.7,4.7,3.1,5c-1.2,0.3-2.2,1.2-2.3,2.5c0,1.6,0.8,2,2.4,3c1.2,0.6,2,1.1,
                2.1,2.3c0,1-0.5,1.6-1.5,1.6c-0.8,0-2.1-0.5-2.6-3.4H1.7v3.9c0,0,2.6,0,3,0c1.8,0,3.4-1.2,
                3.4-3.1c0-2-1.5-2.5-2.7-3.2c-1.2-0.7-1.9-1-1.9-2.1c0-0.8,0.7-1.4,1.6-1.4c0.8,0,1.3,0.6,1.6,1.1c0.3,0.5,0.4,
                1,0.6,1.6h0.4V7.2H4.6v0.4c0.2,0.1,0.5,0.1,0.7,0.2C5.6,8,5.7,8.3,5.7,8.9c0,0.6,0,0.8,0,1.5c0,0.4-0.1,
                1.1-0.3,1.5c-0.2,0.2-0.4,0.3-0.8,0.3c-0.7,0-1-0.6-1.1-1c-0.2-0.8-0.2-2-0.2-3.6c0-1.7,0.2-3.1,
                0.5-3.8c0.3-0.6,0.7-1,1.4-0.9c1,0.1,1.7,1.2,2.1,2.8h0.4V2.5C7.6,2.5,6.2,2.5,5,2.5z`}
        />
      </g>
    </g>
  </svg>
);
